<main class="auth-page">
  <section class="auth-card">
    <div class="brand-mark">
      <mat-icon>settings_suggest</mat-icon>
    </div>
    <h1>Forgot Password</h1>
    <p>Enter your registered email address and we will send a secure password reset link.</p>

    <form (ngSubmit)="submit()">
      <label>
        <span>Email</span>
        <div class="input-shell">
          <mat-icon>mail</mat-icon>
          <input name="email" type="email" [(ngModel)]="email" autocomplete="email" required maxlength="120" />
        </div>
      </label>
      <div class="success" *ngIf="success">{{ success }}</div>
      <div class="error-alert" *ngIf="error">
        <span class="error-icon"><mat-icon>priority_high</mat-icon></span>
        <div>
          <strong>Request failed</strong>
          <p>{{ error }}</p>
        </div>
      </div>
      <button class="auth-btn" type="submit" [disabled]="loading">{{ loading ? 'Sending...' : 'Send Reset Link' }}</button>
      <a class="back-link" routerLink="/login">Back to login</a>
    </form>
  </section>
</main>
